module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Resultado da Importação Secundária")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.semResultado) ? _c('div', {
    staticClass: "resultado-estatísticas-geracao m-b-lg"
  }, [_c('div', [_vm._v("Total de Lotes Enviados: "), _c('span', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _c('div', [_vm._v("Sucesso: "), _c('span', [_vm._v(_vm._s(_vm.totalAtualizadosSucesso))])]), _vm._v(" "), _c('div', [_vm._v("Falhas: "), _c('span', [_vm._v(_vm._s(_vm.relatorio.mensagens.length))])]), _vm._v(" "), _c('div', [_vm._v("Efetividade: "), _c('span', {
    class: _vm.porcentagemEfetividade.class
  }, [_vm._v(_vm._s(_vm.porcentagemEfetividade.valor) + "%")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.semResultado) ? _c('div', {
    staticClass: "text-dark resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Não foi feita importação secundária para este leilão!")])]) : (parseInt(_vm.porcentagemEfetividade.valor) === 100) ? _c('div', {
    staticClass: "text-success resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v("Todos os lotes foram atualizados!")])]) : _c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-whit b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Mensagens de Erro")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.relatorio.mensagens), function(item) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', [_vm._v(_vm._s(item))])])
  }), 0)])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec33365c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/ResultadoImportacaoSecundariaLeilao.vue
// module id = 2019
// module chunks = 19